import { Component } from 'react'
import PropTypes from 'prop-types'
import { EditorState, convertToRaw, convertFromRaw, ContentState, Modifier } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import '!style-loader!css-loader!react-draft-wysiwyg/dist/react-draft-wysiwyg.css' // eslint-disable-line
import htmlToDraft from 'html-to-draftjs'
import { hasJsonStructure } from 'utils/helpers'
import { SpeechToText } from 'components/ideal-core-ui'
import s from './Markdown.scss'

class Markdown extends Component {
  static propTypes = {
    saveCb: PropTypes.func
  }

  state = {
    shouldUpdate: true,
    value:
      this.props.initialValue && this.props.initialValue.trim()
        ? hasJsonStructure(this.props.initialValue)
          ? EditorState.createWithContent(convertFromRaw(JSON.parse(this.props.initialValue)))
          : EditorState.createWithContent(
              ContentState.createFromText(this.props.initialValue.trim(), '\r')
            )
        : EditorState.createEmpty(),
    speechRecording: {}
  }

  componentDidUpdate(prevProps) {
    let newProps = this.props.initialValue
    if (hasJsonStructure(newProps)) {
      newProps = JSON.parse(newProps).blocks[0].text.trim()
    }
    if (
      this.props.shouldDisplayDefaultText &&
      newProps !== prevProps.initialValue &&
      this.state.shouldUpdate
    ) {
      const contentBlock = htmlToDraft(this.props.initialValue)
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
        const editorState = EditorState.createWithContent(contentState)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          value: editorState
        })
      }
    }
  }

  componentWillUnmount() {
    const { speechRecording } = this.state
    speechRecording.stop && speechRecording.stop()
  }

  handleChange = value => {
    const rawContentState = convertToRaw(value.getCurrentContent())
    this.setState({ value, shouldUpdate: false })

    if (this.props.saveCb) {
      this.props.saveCb(JSON.stringify(rawContentState))
    }
  }

  setAudioValue = audioValue => {
    const editorState = this.state.value
    const ncs = Modifier.insertText(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      ' ' + audioValue
    )
    this.handleChange(EditorState.push(editorState, ncs, 'insert-fragment'))
  }

  render() {
    return (
      <Editor
        toolbar={{
          inline: {
            options: ['bold', 'italic', 'underline', 'strikethrough']
          },
          options: [
            'inline',
            'blockType',
            'fontSize',
            'fontFamily',
            'list',
            'link',
            'emoji',
            'image',
            'history'
          ]
        }}
        editorState={this.state.value}
        editorClassName="editorClassName"
        onEditorStateChange={this.handleChange}
        toolbarCustomButtons={[
          <div className={s.audioBtn} key="speech-to-text">
            <SpeechToText
              speechRecording={this.state.speechRecording}
              setValue={this.setAudioValue}
            />
          </div>
        ]}
      />
    )
  }
}

export default Markdown
